import { useRef, useState, useLayoutEffect } from 'react';

export function useContainerWidth() {
  const ref = useRef(null);
  const [width, setWidth] = useState(0);

  useLayoutEffect(() => {
    if (!ref.current) return;
    const el = ref.current;
    let rafId = null;
    const ro = new ResizeObserver((entries) => {
      const cr = entries[0].contentRect;
      // use rAF to avoid layout thrash
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => setWidth(Math.round(cr.width)));
    });
    ro.observe(el);
    return () => {
      ro.disconnect();
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, []);

  return [ref, width];
}
